// extracted by mini-css-extract-plugin
export default {"PFSBody":"PFSBody_PFSBody__XQqdP"};